import { useLazyQuery } from "@apollo/client";
import { ReactNode, useId } from "react";
import { Spinner, UncontrolledTooltip } from 'reactstrap';
import { GET_ORG_PATH } from "../../../graphql/org-gql";
import { GET_ORG_PATH_BY_POSITION } from "../../../graphql/position-gql";
import { IOrgPathResponse } from "../../../types/org";
import './oms-tooltip.scss';

type OmsToolTipProps = {
  orgId?: number;
  positionId?: number;
  id?: string;
  children: ReactNode;
}

const OmsToolTip = (props: OmsToolTipProps) => {
  const { orgId, positionId, children } = props

  const isPosition = (!!positionId && !orgId)

  const gid = useId()
  const id = (props.id ?? gid).replaceAll(':', '_')

  const [getOrgPathByPosition, { data: positionPath, loading: loadingPositionPath }] = useLazyQuery(GET_ORG_PATH_BY_POSITION)
  const [getOrgPath, { data: orgPath, loading: loadingOrgPath }] = useLazyQuery<IOrgPathResponse>(GET_ORG_PATH)

  const onMouseOverEvent = () => {
    if (isPosition)
      getOrgPathByPosition({ variables: { positionId: positionId } })
    else if (orgId)
      getOrgPath({ variables: { id: orgId } })
  }

  return (
    <>
      <span onMouseOver={onMouseOverEvent}
        id={id}
      >
        {children}
      </span>

      <UncontrolledTooltip
        placement="top"
        className="in"
        id={`${id}_tooltip`}
        target={id}
      >
        <div className="tipcontent">
          {isPosition && positionPath?.orgPathByPosition?.map((element: any, index: any) =>
            <div key={index} style={{ marginLeft: `${(index) * 15}px`, whiteSpace: `nowrap` }}>
              <span className={`fa ${index === positionPath?.orgPathByPosition.length - 1 ? "fa-caret-right" : "fa-caret-down"}`} />&nbsp;{element}
            </div>
          )}
          {!isPosition && orgPath?.orgPath?.map((element: any, index: any) =>
            <div key={index} style={{ marginLeft: `${(index) * 15}px`, whiteSpace: `nowrap` }}>
              <span className={`fa ${index === orgPath.orgPath.length - 1 ? "fa-caret-right" : "fa-caret-down"}`} />&nbsp;{element}
            </div>
          )}
          {(loadingOrgPath || loadingPositionPath) ? <Spinner size="sm" aria-busy="true" /> :
            (!orgPath?.orgPath || orgPath.orgPath.length === 0) &&
            (!positionPath?.orgPathByPosition || positionPath.orgPathByPosition.length === 0) &&
            <>N/A</>
          }
        </div>
      </UncontrolledTooltip>
    </>
  )
}

export default OmsToolTip;


